import React from "react";
import withHooks, { useEffect } from "react-with-hooks";
import { withRouter } from "react-router-dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import ScrollLock, { TouchScrollable } from "react-scrolllock";
import { Field } from "redux-form";

import InputStyles from "../../utils/Checkbox/styles.module.css";
import WithUserForm from "../../Register/WithUserForm";

import logoBlack from "../../../assets/images/Logo_black_plain.svg";
import styles from "./styles.module.css";
import stylesTermOfUse from "./terms.module.css";
import stylesButton from "../../utils/css/button.module.css";

const isHashLink = (href) => href.indexOf("#") === 0;

let RouterLink = (props) =>
  isHashLink(props.href) ? (
    <a
      {...props}
      children={props.children}
      href={undefined}
      onClick={() => {
        const el = document.querySelector(props.href);
        el && el.scrollIntoView();
      }}
    />
  ) : (
    <a children={props.children} {...props} />
  );

const useEscapeKey = (cb) => {
  const onKeyup = (event) => {
    return (event.key === "Escape" || event.keyCode === 27) && cb();
  };

  useEffect(() => {
    window.addEventListener("keyup", onKeyup, true);
    return function cleanup() {
      window.removeEventListener("keyup", onKeyup, true);
    };
  });
};

const usePreventBodyScroll = () => {
  useEffect(() => {
    const el =
      document.querySelector("#modal-scroll") ||
      document.querySelector(`.${styles.ModalBody}`);
    disableBodyScroll(el);
    return () => {
      enableBodyScroll(el);
    };
  });
};

RouterLink = withRouter(RouterLink);

let ModalLegalAgreements = withHooks(({ title, history, children, termsOfUse }) => {
  const AcceptedTosInput = withHooks(({ input, ...props }) => {
    return (
      <>
        <div className={styles.checked_accept}>
          <label className={InputStyles.wrap_checkbox}>
            <input
              type="checkbox"
              className={InputStyles.wrap_checkbox_input}
              {...input}
              {...props}
              checked={input.value}
            />
            <span className={InputStyles.check_mark} />
          </label>
          I accept
        </div>
        <button
          disabled={!input.value}
          className={`${stylesButton.button} ${styles.button}`}
          onClick={() => history.goBack()}
        >
          Confirm
        </button>
      </>
    );
  });

  usePreventBodyScroll();
  useEscapeKey(() => history.goBack());
  return (
    <div className={termsOfUse ? stylesTermOfUse.modal : styles.modal}>
      <div className={termsOfUse ? stylesTermOfUse.wrap_modal : styles.wrap_modal}>
        <div className={termsOfUse ? stylesTermOfUse.modal_head : styles.modal_head}>
          <img src={logoBlack} alt="" />
          <p>{title}</p>
        </div>
        <img
          className={styles.close_icon}
          alt="close"
          src={require("./x-icon.svg")}
          onClick={() => history.goBack()}
        />
        <ScrollLock>
          <div className={termsOfUse ? stylesTermOfUse.modal_content : styles.modal_content}>{children}</div>
        </ScrollLock>
      </div>
    </div>
  );
});

ModalLegalAgreements = withRouter(ModalLegalAgreements);

export default ModalLegalAgreements;
